import { Dispatch, SetStateAction } from 'react'
import { TablePaginationConfig } from 'antd/lib/table'

import { BulkHistoryDataFilters } from '@types'

interface FiltersContextType {
  filters?: BulkHistoryDataFilters
  setFilters: Dispatch<SetStateAction<BulkHistoryDataFilters>>
}

const useBulkDataHistoryPagination = (
  { filters, setFilters }: FiltersContextType,
  total?: number,
) =>
  ({
    total,
    pageSize: filters?.limit,
    current: filters?.page || 1,
    position: ['bottomCenter'],
    size: 'small',
    showSizeChanger: false,
    showQuickJumper: false,
    onChange: page => setFilters(prev => ({ ...prev, page })),
  } as TablePaginationConfig)

export { useBulkDataHistoryPagination }
